import { useNavigate, useParams } from "react-router-dom";
import { Autocomplete, Button, Input, Modal, Spinner } from "src/components";
import InvoiceLayout from "src/pages/invoice-master/invoice-layout.component";
import PurpleLeftArrowIcon from "src/features/fields/assets/purple-left-arrow.svg";
import { useToast } from "src/hooks/useToast";
import { RootState } from "src/context/store";
import { useDispatch, useSelector } from "react-redux";
import { downloadInvoice, fetchEinvoicesData } from "src/services/invoice-api";
import EInvoiceReject from "./E-InvoiceReject";
import { useEffect, useState } from "react";
import EInvoiceAccept from "./E-InvoiceAccept";
import { invoiceActions } from "src/context/invoice-slice";
//M10-11909
import Book from "src/assets/book.png";
import { MessageSquareText } from "lucide-react";
import { useOutsideClick } from "src/hooks/useOutsideClick";
import VersioningCrate from "src/components/Versioning/versioningModal.component";
import QRCode from "qrcode";
import AddFeedbackForm from "src/pages/feedback/add-feedback-form.component";
import { addFeedback } from "src/services/feedback-api";
//M10-11909
import { EINVOICE_REF_TYPES, getEInvoiceReferenceErrors, isValidIrn, requiresIrn } from "./eInvoiceReference"; // M10-16235
// import { useEventStatus } from "src/hooks/useEventStatus";

const EInvoiceDetails = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { selectedEInvoice ,EInvoiceFilters} = useSelector((state: RootState) => state.invoice); //M10-11685
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
  const [tableData, setTableData] = useState<{ label: string; einvoice: string; invoice: string }[]>([]);
  const { einvoice_dtl_id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  // const [irn, setIrn] = useState<string>(" ");
  // const [ewayBillAmount, setEwayBillAmount] = useState<number>(0);
  // const [ewayBillDate, setEwayBillDate] = useState<string>("");
  // const [updatingEInvoice, setUpdatingEInvoice] = useState(false);
  const dispatch = useDispatch();
  // const { withEventCheck } = useEventStatus();
  //M10-11909
  const [VersioningModal, setVersioningModal] = useState(false);
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const outSideClickRef = useOutsideClick(() => {
    setVersioningModal(false);
  });
  //M10-11909

  const [qr, setQr] = useState("");
  const [showModal, setShowModal] = useState<boolean>(false);

  // M10-16235: reference type / IRN the reviewer confirms before accepting
  const [refType, setRefType] = useState<string>("");
  const [irn, setIrn] = useState<string>("");
  const [showRefErrors, setShowRefErrors] = useState<boolean>(false);
  const isPending = selectedEInvoice?.einvoice_status === "pending";
  const canSelectRefType = isPending && !selectedEInvoice?.einvoice_ref_type;
  const canEditIrn = isPending && requiresIrn(refType) && !isValidIrn(selectedEInvoice?.irn_number);
  const refErrors = getEInvoiceReferenceErrors(refType, irn);

  const generateQR = async (url: any) => {
    try {
      const qrDataUrl = await QRCode.toDataURL(url);
      setQr(qrDataUrl);
      setShowModal(true);
    } catch (err) {
      console.error(err);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setQr("");
  };

  const stockistInvoiceAttachment = selectedEInvoice?.einvoice_attachment?.attachment_type === "eway" ?
    selectedEInvoice?.stockistInvoiceAttachmentEway :
    selectedEInvoice?.stockistInvoiceAttachment;

  const getEInvoicesData = async (page_size: number, page_number: number) => {
    setIsLoading(true);
    if (!einvoice_dtl_id) return;
    try {
      setIsLoading(true);
      const res = await fetchEinvoicesData({ page_size, page_number, einvoice_dtl_id: einvoice_dtl_id || null ,company_code:EInvoiceFilters?.company?.[0]?.code}); //M10-11685
      dispatch(invoiceActions.setSelectedEInvoice(res?.data?.data?.eInvoices?.[0]));
      setIsLoading(false);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      toast({
        variant: "destructive",
        description: "Failed to load e-invoices",
      });
      setIsLoading(false);
    }
  };

  // const handleSubmit = async () => {
  //   setUpdatingEInvoice(true);
  //   const payload = {
  //     "data":
  //     {
  //       "einvoice_dtl_id": selectedEInvoice?.einvoice_dtl_id,
  //       "einvoice_status": selectedEInvoice?.einvoice_status,
  //       // invoice DTL
  //       "invoice_number": selectedEInvoice?.invoice_number,
  //       "irn_number": irn,
  //       "amount": ewayBillAmount,
  //       "einvoice_ref_type": "IRN",
  //       "invoice_date": selectedEInvoice?.invoice_date,
  //       "irn_date": ewayBillDate,
  //       // // Invoice Attachment
  //       // "total_count": 5,
  //       // "error_count": 0, 
  //       // "my_use": 1,      
  //       // "not_in_use": 1,  
  //       // "document_names": ["doc2.pdf", "dfsg"],
  //       "attachment_type": selectedEInvoice?.einvoice_attachment?.attachment_type,
  //       "buyer_gst": selectedEInvoice?.buyer_gst,
  //       "seller_gst": selectedEInvoice?.seller_gst,
  //       "hsncode": selectedEInvoice?.hsncode,
  //       "item_count": selectedEInvoice?.item_count
  //     }
  //     ,
  //     "primary_key": stockistInvoiceAttachment?.stockist_invoice_attachment_id,
  //     "event_type": "E_INVOICE_EDIT"
  //   }
  //   try {
  //     const response = await eInvoiceEdit(payload);
  //     const res = await withEventCheck(
  //       () => {
  //         return getEInvoicesData(10, 1);
  //       },
  //       response?.data?.data?.eventStreamCreated?.streamId
  //     );
  //     console.log(res);
  //     toast({ description: "E-Invoice updated successfully", variant: "default" });
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setUpdatingEInvoice(false);
  //   }

  // }

  useEffect(() => {
    if (selectedEInvoice) {
      setTableData([
        {
          label: "Invoice No.",
          invoice: stockistInvoiceAttachment?.stockist_invoice_number,
          einvoice: selectedEInvoice?.invoice_number || "",
        },
        {
          label: "Fuid",
          invoice: stockistInvoiceAttachment?.fuid_no,
          einvoice: selectedEInvoice?.mapped_fuid_number || "",
        },
        {
          label: "Order No",  // MEDVOL: M10-10639 changes
          invoice: stockistInvoiceAttachment?.orderCodes?.map((code: any) => code?.order_code).join(", ") || "",
          einvoice: selectedEInvoice?.orderCodes?.map((code: any) => code?.order_code).join(", ") || "",
        },
        {
          label: "Seller Gst",
          invoice: stockistInvoiceAttachment?.stockist_gst_number,
          einvoice: selectedEInvoice?.seller_gst || "",
        },
        {
          label: "Buyer Gst",
          invoice: stockistInvoiceAttachment?.counter_gst_number,
          einvoice: selectedEInvoice?.buyer_gst || "",
        },
        // MEDVOL: M10-10639 changes
        {
          label: "Invoice Date",
          invoice: stockistInvoiceAttachment?.invoice?.new_invoice_date
            ? `${new Date(stockistInvoiceAttachment?.invoice?.new_invoice_date).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}, ${new Date(stockistInvoiceAttachment?.invoice?.new_invoice_date).toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}` : "",
          einvoice: selectedEInvoice?.invoice_date
            ? `${new Date(selectedEInvoice.invoice_date).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}, ${new Date(selectedEInvoice.invoice_date).toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}` : "",
        },
         {
          label: "File Upload Date",
          invoice: stockistInvoiceAttachment?.created_date
            ? `${new Date(stockistInvoiceAttachment?.created_date).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}, ${new Date(stockistInvoiceAttachment?.created_date).toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}` : "",
          einvoice: selectedEInvoice?.einvoice_attachment?.uploaded_date
            ? `${new Date(selectedEInvoice.einvoice_attachment?.uploaded_date).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}, ${new Date(selectedEInvoice.einvoice_attachment?.uploaded_date).toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}` : "",
        },
        {
          label: "Invoice Amount",
          invoice: stockistInvoiceAttachment?.invoice?.net_amount,
          einvoice: selectedEInvoice?.amount || "",
        },
        // MEDVOL: M10-10639 changes
        // {
        //   label: "Stockist Id",
        //   invoice: stockistInvoiceAttachment?.stockist_id,
        //   einvoice: selectedEInvoice?.einvoice_attachment?.stockist_id || "",
        // },
        { label: "QR/IRN", invoice: stockistInvoiceAttachment?.invoice?.e_inv_ref_type, einvoice: selectedEInvoice?.einvoice_ref_type || "" },
        { label: "IRN", invoice: stockistInvoiceAttachment?.invoice?.irn, einvoice: selectedEInvoice?.irn_number || "" },
        { label: "City", invoice: stockistInvoiceAttachment?.state_district_city?.split(",")[2], einvoice: selectedEInvoice?.city || "" },
        { label: "MCI No.", invoice: stockistInvoiceAttachment?.counter_mci_number, einvoice: selectedEInvoice?.mci_no || "" },
        // { label: "DL Number*", invoice: "", einvoice: selectedEInvoice?.dl_number || "" },
        { label: "GST No.*", invoice: stockistInvoiceAttachment?.counter_gst_number, einvoice: selectedEInvoice?.gst_no || "", },
        { label: "GST Status", invoice: stockistInvoiceAttachment?.counter_gst_status == true ? "Active" : "Inactive", einvoice: selectedEInvoice?.gst_status || "" },
      ]);
    }
    // M10-16235
    setRefType(selectedEInvoice?.einvoice_ref_type || "");
    setIrn(selectedEInvoice?.irn_number || "");
    setShowRefErrors(false);
    // setEwayBillAmount(selectedEInvoice?.amount || 0);
    // setEwayBillDate(selectedEInvoice?.irn_date || "");
    // setIrn(selectedEInvoice?.irn_number || " ");
  }, [selectedEInvoice]);

  useEffect(() => {
    getEInvoicesData(10, 1);
  }, [einvoice_dtl_id]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner />
      </div>
    );
  }

  const handleFormSubmit = async (payload: any): Promise<boolean> => {
    setLoading(true);
    try {
      const finalPayload = {
        ...payload,
        reference_number: `EInvoice-${payload.reference_number}`,
      };
      
      const res = await addFeedback(finalPayload);

      if (res?.status === 200) {
        toast({ description: "Feedback submitted successfully" });
        return true;
      } else {
        toast({
          variant: "destructive",
          description: res?.data?.message || "Failed to submit feedback",
        });
        return false;
      }
    } catch (err: any) {
      toast({
        variant: "destructive",
        description: err?.message || "Failed to submit feedback",
      });
      return false;
    } finally {
      setIsFeedbackModalOpen(false);
      setLoading(false);
    }
  };

  return (
    <InvoiceLayout>
      <div className="">
        <div className="flex flex-col items-start px-[3.75rem] mt-6 pb-12 shadow-md border-b-[1px] border-b-[#E9E9E9]">
          <Button className="py-2 text-lg text-[#7F56D9]" onClick={() => navigate("/transactions/invoice/2")}>
            <img src={PurpleLeftArrowIcon} alt="back" className="w-3 h-3 mr-3" />
            Back to Invoices
          </Button>
          <h1 className="text-[#49484C] font-bold text-[2rem]">E-Invoices</h1>
          {/* //M10-11909 */}
          <div className="absolute right-4 flex flex-row gap-3 items-end mt-24">
            <MessageSquareText
              onClick={() => setIsFeedbackModalOpen(true)}
              className="text-gray-700 text-[12px] cursor-pointer mb-2"
            />

            {/* Versioning */}
            <div
              onClick={() => setVersioningModal((prev) => !prev)}
            >
              <img src={Book} alt="Version" className="h-10 w-14 " />
            </div>
          </div>
        </div>
        {VersioningModal && (
          <div ref={outSideClickRef}>
            <VersioningCrate type="EInvoice" stockistInvAttachmentId={selectedEInvoice?.stockistInvoiceAttachment?.stockist_invoice_attachment_id} />
          </div>
        )}
        {/* //M10-11909 */}
        <div className="flex px-[3.75rem] mt-10 items-center justify-between gap-x-2">
          <div className="flex items-center gap-x-2">
            <p className="text-2xl font-semibold">{stockistInvoiceAttachment?.company_name}</p>
            <h1
              className={`font-semibold  flex items-center text-xs h-6 px-2 rounded-full`}
              style={{
                backgroundColor:
                  selectedEInvoice?.einvoice_status == "accepted"
                    ? "#D3F6E4"
                    : selectedEInvoice?.einvoice_status == "pending"
                      ? "#FFF9ED"
                      : "#FEE9E8",
                color:
                  selectedEInvoice?.einvoice_status == "accepted"
                    ? "#207A65"
                    : selectedEInvoice?.einvoice_status == "pending"
                      ? "#996B0F"
                      : "#8E1F0B",
              }}
            >
              {selectedEInvoice?.einvoice_status}
            </h1>
          </div>
          <div className="flex items-center p-2 rounded-md bg-[#f1f1f1]">
           {selectedEInvoice?.signed_qr_code && <Button
              className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1] border-gray-500 rounded-r-none border-r rounded-l-md h-5 hover:text-gray-600 focus:outline-none focus:ring-0"
              onClick={() => {
                generateQR(selectedEInvoice?.signed_qr_code)
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <span>View QR</span>
            </Button>}
            {showModal && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: "rgba(0,0,0,0.5)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 1000,
                }}
                onClick={closeModal} // close on background click
              >
                <div
                  style={{
                    backgroundColor: "#fff",
                    padding: 20,
                    borderRadius: 8,
                    textAlign: "center",
                  }}
                  onClick={(e) => e.stopPropagation()} // prevent closing when clicking QR
                >
                  {/* <h3>QR Code</h3> */}
                  {qr && <img src={qr} alt="QR Code" style={{ width: 300, height: 300 }} />}
                </div>
              </div>
            )}
            {/* M10-12130 */}
                <Button
              className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1] border-gray-500 rounded-r-none border-r rounded-l-md h-5 hover:text-gray-600 focus:outline-none focus:ring-0"
              onClick={() => {
                console.log(stockistInvoiceAttachment,"Download")
                if (!stockistInvoiceAttachment?.einv_attachment_path) {
                  toast({ description: "File cannot be download for Categories 3", variant: "destructive" });
                  return;
                }
                downloadInvoice(stockistInvoiceAttachment?.einv_attachment_path, stockistInvoiceAttachment?.company_code).then((res: any) => {
                  if (res?.data?.success && res?.data?.data) {
                    window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                  } else {
                    console.error("Failed to download the invoice.");
                  }
                });
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M7 8l5 5m0 0l5-5m-5 5V3" />
              </svg>
              <span>Download E-Invoice</span>
            </Button>
            {/* M10-12130 */}
            <Button
              className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1] border-gray-500 rounded-r-none border-r rounded-l-md h-5 hover:text-gray-600 focus:outline-none focus:ring-0"
              onClick={() => {
                if (!stockistInvoiceAttachment?.file_path) {
                  toast({ description: "Invoice not found", variant: "destructive" });
                  return;
                }
                downloadInvoice(stockistInvoiceAttachment?.file_path, stockistInvoiceAttachment?.company_code).then((res: any) => {
                  if (res?.data?.success && res?.data?.data) {
                    window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                  } else {
                    console.error("Failed to download the invoice.");
                  }
                });
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M7 8l5 5m0 0l5-5m-5 5V3" />
              </svg>
              <span>Download Invoice</span>
            </Button>
            <Button className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1]  border-none rounded-none h-5 hover:text-gray-600 focus:outline-none focus:ring-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M12 5l7 7-7 7" />
              </svg>
              <span>Preview</span>
            </Button>
            <Button className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1] border-gray-500 border-l rounded-l-none rounded-r-md h-5 hover:text-gray-600 focus:outline-none focus:ring-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 5.636a9 9 0 11-12.728 0m12.728 0L12 12m0 0l-6.364-6.364" />
              </svg>
              <span>Report an issue</span>
            </Button>
          </div>
        </div>

        <div className="p-6 mt-10 border border-[#D0D0D0] shadow-sm mx-[3.75rem] mb-20 rounded-lg">
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              textAlign: "left",
              border: "1px solid #ccc",
            }}
            className=""
          >
            <thead>
              <tr className="text-sm bg-[#F1F1F1]">
                <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}></th>
                <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>As per Invoice Already Entered</th>
                <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>As per Acknowledged Copy</th>
                {/* <th style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index} className="w-full">
                  <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-1/3 text-gray-500">
                    {/* <input type="checkbox" /> */}
                    <span className="ml-2 text-sm font-normal">{row.label}</span>
                  </td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-1/3 text-sm">
                    {row.invoice}
                  </td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-1/3 text-sm">
                    {/* M10-16235: reference type is selectable only when the e-invoice has none */}
                    {row.label === "QR/IRN" && canSelectRefType ? (
                      <div className="w-[60%]">
                        <Autocomplete
                          placeholder="Select QR/IRN"
                          defaultValue={refType}
                          suggestionList={EINVOICE_REF_TYPES.map((type) => ({ key: type, value: type }))}
                          onSelectionChange={(e: any) => setRefType(e?.value || "")}
                          displayKey="key"
                        />
                        {showRefErrors && refErrors.refType && <p className="text-red-500 text-xs ml-3 mt-1">{refErrors.refType}</p>}
                      </div>
                    ) : row.label === "IRN" && canEditIrn ? (
                      <Input
                        placeholder="Enter 64-character IRN"
                        className="w-full"
                        value={irn}
                        onChange={(e) => setIrn(e.target.value.trim())}
                        isError={showRefErrors && !!refErrors.irn}
                        errorMessage={refErrors.irn}
                      />
                    ) : (
                      row.einvoice
                    )}
                  </td>
                  {/* {selectedEInvoice?.einvoice_attachment?.attachment_type === "eway" ?
                    <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-1/3 text-sm">
                      {row.label === "IRN" &&
                        <Input
                          type="text"
                          value={irn}
                          onChange={(e) => { setIrn(e.target.value?.trim()) }}
                        />}
                      {row.label === "E-way Bill Amount" &&
                        <Input
                          type="number"
                          value={ewayBillAmount}
                          onChange={(e) => { setEwayBillAmount(Number(e.target.value?.trim())) }}
                        />}
                      {row.label === "E-way Bill Date" &&
                        <Input
                          type="date"
                          value={ewayBillDate ? ewayBillDate.split("T")[0] : ewayBillDate}
                          max={new Date().toISOString().split("T")[0]}
                          onChange={(e: any) => {
                            const dateValue = e.target.value;
                            const selectedDate = new Date(dateValue);

                            const now = new Date();

                            // Set time using UTC values
                            selectedDate.setUTCHours(now.getUTCHours());
                            selectedDate.setUTCMinutes(now.getUTCMinutes());
                            selectedDate.setUTCSeconds(now.getUTCSeconds());
                            selectedDate.setUTCMilliseconds(now.getUTCMilliseconds());

                            const formattedDate = selectedDate.toISOString(); // This will be in UTC
                            setEwayBillDate(formattedDate);
                          }} />}
                    </td> : <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }} className="w-1/3 text-sm"></td>} */}
                </tr>
              ))}
            </tbody>
          </table>
          <div className="flex items-center justify-end mt-14 gap-x-2">
            {selectedEInvoice?.einvoice_status === "pending" && <div className="flex gap-x-2">
              <Button
                className="font-normal px-4 py-2 bg-gray-200 border border-gray-300"
                onClick={() => {
                  setIsRejectModalOpen(true);
                }}
              // disabled={updatingEInvoice}
              >
                Reject
              </Button>
              <Button
                // disabled={updatingEInvoice}
                className="font-normal px-4 py-2 text-white bg-[#8051FF]"
                onClick={() => {
                  // M10-16235: block acceptance until the reference type / IRN are valid
                  setShowRefErrors(true);
                  const error = refErrors.refType || refErrors.irn;
                  if (error) {
                    toast({ description: error, variant: "destructive" });
                    return;
                  }
                  setIsAcceptModalOpen(true);
                }}>
                Accept
              </Button>
            </div>}
            {/* <div>
              <Button
                disabled={updatingEInvoice}
                isLoading={updatingEInvoice}
                loaderSize="small"
                onClick={handleSubmit}
                className="font-normal px-4 py-2 text-white bg-[#8051FF]"
              >
                Submit
              </Button>
            </div> */}
          </div>
        </div>
        <Modal isOpen={isRejectModalOpen} onCloseModal={() => setIsRejectModalOpen(false)} isHeader={false}>
          <EInvoiceReject
            onSuccess={() => {
              setIsRejectModalOpen(false);
              getEInvoicesData(10, 1);
            }}
            eInvoiceData={selectedEInvoice}
            primary_key={stockistInvoiceAttachment?.stockist_invoice_attachment_id}
            einvoice_dtl_id={selectedEInvoice?.einvoice_dtl_id}
            onCloseModal={() => setIsRejectModalOpen(false)}
          />
        </Modal>
        <Modal isOpen={isAcceptModalOpen} onCloseModal={() => setIsAcceptModalOpen(false)} isHeader={false}>
          <EInvoiceAccept
            onSuccess={() => {
              setIsAcceptModalOpen(false);
              getEInvoicesData(10, 1);
            }}
            eInvoiceData={selectedEInvoice}
            primary_key={stockistInvoiceAttachment?.stockist_invoice_attachment_id}
            einvoice_dtl_id={selectedEInvoice?.einvoice_dtl_id}
            onCloseModal={() => setIsAcceptModalOpen(false)}
            einvoiceRefType={refType}
            irnNumber={irn}
          />
        </Modal>
        
        {isFeedbackModalOpen && (
          <Modal isOpen={isFeedbackModalOpen} isHeader={true} title="Feedback" onCloseModal={() => setIsFeedbackModalOpen(false)}>
            <AddFeedbackForm
              onFormSubmit={handleFormSubmit}
              defaultValues={{ reference_number: selectedEInvoice?.mapped_fuid_number, type: { name: "Invoices", id: "invoice" } }}
              isLoading={loading}
            />
          </Modal>
        )}
      </div>
    </InvoiceLayout>
  );
};

export default EInvoiceDetails;
